import { useState } from 'react';
import { LayoutChangeEvent, useWindowDimensions, View } from 'react-native';
import RenderHTML from 'react-native-render-html';
import {
  CONTENT_PADDING,
  htmlTagStyles,
  MODAL_MAX_WIDTH,
  styles,
} from './styles';

interface ConsentModalContentProps {
  consentText?: string;
}

export default function ConsentModalContent({
  consentText,
}: ConsentModalContentProps) {
  const { width: windowWidth } = useWindowDimensions();
  // Measure the real container: the modal shell differs between apps
  // (patient caps at 768, therapist pads 64), so a fixed width would make
  // RenderHTML overflow. Fall back to the window estimate for the first paint.
  const [layoutWidth, setLayoutWidth] = useState<number | null>(null);
  const outerWidth = layoutWidth ?? Math.min(windowWidth, MODAL_MAX_WIDTH);
  const contentWidth = outerWidth - CONTENT_PADDING * 2;

  const onLayout = (event: LayoutChangeEvent) => {
    setLayoutWidth(event.nativeEvent.layout.width);
  };

  if (!consentText) {
    return null;
  }

  return (
    // No ScrollView here — the Dialog shell scrolls this content in both apps.
    <View style={styles.wrapper} onLayout={onLayout}>
      <RenderHTML
        tagsStyles={htmlTagStyles}
        contentWidth={contentWidth}
        source={{ uri: consentText }}
      />
    </View>
  );
}
